'use client';

import Image from 'next/image';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

import {
  ABOUT_HERO,
  ABOUT_MISSION,
  ABOUT_NEWS,
  ABOUT_TEAM,
} from '../about-content';
import './../about-page.css';

function SectionHeading({ children }: { children: string }) {
  return <h2 className="about-section-head">{children}</h2>;
}

function scrollToTeam() {
  document.getElementById('belowfold')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/**
 * Legacy About visual design (green hero, 2-up team, news logos),
 * rewritten with shadcn primitives. Marketing navbar/footer come from the route shell.
 */
export function AboutPage() {
  return (
    <main className="about-page bg-white text-[#333]">
      <section className="about-banner-outter-wrap">
        <div className="about-banner-content-wrap">
          <h1>
            Meet the{' '}
            <br />
            KudosWall Family
          </h1>
          <p>{ABOUT_HERO.description}</p>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            aria-label="Scroll to our mission"
            onClick={scrollToTeam}
            className="about-banner-scroll"
          >
            <svg
              aria-hidden
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 5v14" />
              <path d="m19 12-7 7-7-7" />
            </svg>
          </Button>
        </div>
      </section>

      <section id="belowfold" className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="our-mission-main-wrap">
          <SectionHeading>{ABOUT_MISSION.heading}</SectionHeading>
          <Card className="gap-0 border-0 bg-transparent py-0 shadow-none">
            <CardContent className="px-0">
              <p>“{ABOUT_MISSION.quote}”</p>
            </CardContent>
          </Card>
        </div>
      </section>

      <section id="team" className="mx-auto max-w-5xl px-4 pb-6 sm:px-6 lg:px-8">
        <SectionHeading>the team</SectionHeading>
        <ul className="about-team">
          {ABOUT_TEAM.map((member) => (
            <li key={member.name}>
              <Card className="w-full gap-0 border-0 bg-transparent py-0 shadow-none">
                <CardContent className="flex flex-col items-center px-2 text-center sm:px-4">
                  <Image
                    src={member.imageSrc}
                    alt={member.name}
                    width={120}
                    height={120}
                  />
                  <h3>{member.name}</h3>
                  <p>{member.role}</p>
                </CardContent>
              </Card>
            </li>
          ))}
        </ul>
      </section>

      <section className="mx-auto max-w-5xl px-4 pb-10 sm:px-6 lg:px-8">
        <SectionHeading>kudoswall in the news</SectionHeading>
        <ul className="about-kudos-news">
          {ABOUT_NEWS.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={item.label}
              >
                <Image
                  src={item.imageSrc}
                  alt={item.label}
                  width={160}
                  height={80}
                />
              </a>
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
}
